/**
 * Temporary "coming soon" wall.
 *
 * On by default so a production build needs no extra env wiring. To take the
 * wall down, set REACT_APP_COMING_SOON=false (Vercel env var, or .env locally)
 * and redeploy — no code change or revert required.
 */
export const COMING_SOON_ENABLED =
  String(process.env.REACT_APP_COMING_SOON ?? "true").toLowerCase() !== "false";

/**
 * Routes that stay reachable while the wall is up, so an admin can still
 * authenticate. There is deliberately no link to these from the wall itself.
 */
export const COMING_SOON_ALLOWED_PATHS = ["/login", "/callback"];
